import { render, staticRenderFns } from "./SepaForm.vue?vue&type=template&id=107a6a47&scoped=true&"
import script from "./SepaForm.vue?vue&type=script&lang=ts&"
export * from "./SepaForm.vue?vue&type=script&lang=ts&"
import style0 from "./SepaForm.vue?vue&type=style&index=0&id=107a6a47&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107a6a47",
  null
  
)

export default component.exports